function reducer(state, action) {
  const { type, payload } = action;
  switch (type) {
    case 'START_LOAD_DATA':
      return {
        ...state,
        items: null,
        totalCount: null,
      };
    case 'FINISH_LOAD_DATA':
      return {
        ...state,
        items: payload.items,
        totalCount: payload.totalCount,
      };
    case 'SET_EDITABLE_FILTER':
      return {
        ...state,
        editableFilter: payload,
        pagination: { pageNumber: 1, pageSize: state.pagination.pageSize },
      };
    case 'UPDATE_SELECTED_COLUMNS':
      return {
        ...state,
        selectedColumns: payload,
      };
    case 'UPDATE_ALL_COLUMNS':
      return {
        ...state,
        allColumns: payload,
      };
    case 'UPDATE_SORTED_COLUMN':
      return {
        ...state,
        sortedColumn: payload,
      };
    case 'UPDATE_PAGINATION':
      return {
        ...state,
        pagination: payload,
      };
    case 'UPDATE_SEGMENTATION':
      return {
        ...state,
        segmentation: payload,
      };
    case 'REFRESH_GRID_DATA':
      return {
        ...state,
        dataRefreshId: (state.dataRefreshId + 1) % Number.MAX_SAFE_INTEGER,
      };
    case 'TABLE_DID_MOUNT':
      return state;
    case 'TABLE_DID_UPDATE':
      return state;
    case 'SET_ITEMS_IN_ALL_PAGES':
      return {
        ...state,
        sourceItemsInAllPages: payload,
      };
    default:
      return state;
  }
}

const getInitialState = (props) => {
  const {
    allColumns, selectedColumns, sortedColumn, segmentation, pagination, filter, initAllItems,
  } = props;
  return {
    allColumns: allColumns || [],
    items: [],
    selectedItems: [],
    selectedColumns: selectedColumns || [],
    sortedColumn: sortedColumn || {},
    segmentation: segmentation || {},
    editableFilter: filter || [],
    pagination: pagination || {
      pageNumber: 1,
      pageSize: 20,
    },
    dataRefreshId: 0,
    sourceItemsInAllPages: initAllItems || [], // for client side sorting/paging/filtering
  };
};

export default {
  reducer,
  getInitialState,
};
